import moment from 'moment';
import * as React from 'react';
export default function DateTime(props) {
    var initialVal = props.initialVal, _a = props.isLive, isLive = _a === void 0 ? false : _a, _b = props.updateInterval, updateInterval = _b === void 0 ? 1000 : _b, _c = props.onFormat, onFormat = _c === void 0 ? function (dateVal) { return dateVal.format(); } : _c;
    var _d = React.useState(), dateVal = _d[0], setDateVal = _d[1];
    var _e = React.useState(), intervalRef = _e[0], setIntervalRef = _e[1];
    React.useEffect(function () {
        setDateVal(initialVal);
    }, [initialVal]);
    React.useEffect(function () {
        if (isLive) {
            var iRef = setInterval(function () {
                setDateVal(moment());
            }, updateInterval);
            setIntervalRef(iRef);
        }
        return function () {
            clearInterval(intervalRef);
        };
    }, []);
    return React.createElement("span", null, dateVal ? onFormat(dateVal) : '');
}
//# sourceMappingURL=DateTime.js.map